import { Logger, EngineComponentFactory } from "neo-common";
import { ComponentTypes } from "../ComponentTypes";
import { HtmlElement } from "../../HTMLComponents/Elements/HtmlElement";
import { UserControls } from "../../Channels/Common/UserControls/UserControls";
import { GameManager } from "../../Managers/GameManager";
import { ModuleManager } from "../../Managers/ModuleManager";
import { GambleUserControls } from "../../Channels/Common/UserControls/GambleUserControls";
import { DesktopBaseUserControls } from "../../Channels/Desktop/DesktopBaseUserControls";
import { MobileBaseUserControls } from "../../Channels/Mobile/MobileBaseUserControls";
import { AppContext } from "../../../Common/AppContext";
import { DesktopFreespinsUserControls } from "../../Channels/Desktop/DesktopFreespinsUserControls";
import { MobileFreespinsUserControls } from "../../Channels/Mobile/MobileFreespinsUserControls";

/**
 * The HtmlManager class is used for parsing html elements which are extending html element and append them to index.html.
 * @class HtmlManager
 */
export class HtmlManager {
    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("HtmlManager", data);
        }
    }

    /**
     * Parse html elements from xml and append them to index.html.
     * @method parseElements
     * @param startNode Element
     * @param parent HtmlElement
     * @return void
     */
    static parseElements(startNode: Element, parent: HtmlElement = null): Object {
        const children: Object = {};

        if (!startNode) {
            return;
        }

        HtmlManager.getNodesList(startNode.firstElementChild, [])
            .reverse()
            .filter(
                (node: Element) =>
                    node.hasAttribute("Class") &&
                    EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes.HtmlElement),
            )
            .forEach((node: Element) => {
                const element: any = EngineComponentFactory.get(node.getAttribute("Class"));
                const root: HTMLElement = document.getElementById("root");
                let customRoot: HTMLElement;

                if (node.hasAttribute("RootId")) {
                    customRoot = document.getElementById(node.getAttribute("RootId"));
                }

                if (node.hasAttribute("Key")) {
                    if (!AppContext.gameDefinition.Gamble && node.getAttribute("Key") === "gamble") {
                        return;
                    }

                    if (element instanceof DesktopBaseUserControls) {
                        ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
                    } else if (element instanceof MobileBaseUserControls) {
                        ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
                    } else if (element instanceof GambleUserControls) {
                        ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
                    } else if (element instanceof DesktopFreespinsUserControls) {
                        ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
                    } else if (element instanceof MobileFreespinsUserControls) {
                        ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
                    }
                }

                if (element.instance != null) {
                    if (parent != null) {
                        parent.instance.appendChild(element.instance);
                    } else {
                        if (customRoot != null) {
                            customRoot.appendChild(element.instance);
                        } else if (root != null) {
                            root.appendChild(element.instance);
                        } else {
                            document.body.appendChild(element.instance);
                        }
                    }
                    element.create(node);
                } else {
                    element.create(node);
                    if (parent != null) {
                        parent.instance.appendChild(element.instance);
                    } else {
                        if (customRoot != null) {
                            customRoot.appendChild(element.instance);
                        } else if (root != null) {
                            root.appendChild(element.instance);
                        } else {
                            document.body.appendChild(element.instance);
                        }
                    }
                }

                children[node.nodeName] = element;
            });

        return children;
    }

    /**
     * Recursively extracts sibling nodes.
     * @method getNodesList
     * @param node Element
     * @param nodeList Array<Element>
     * @return Array<Element>
     */
    private static getNodesList(node: Element, nodeList: Array<Element>): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = HtmlManager.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/HtmlManager.ts
 **/